import { render, staticRenderFns } from "./CardDetail.vue?vue&type=template&id=e5a24b9a&scoped=true&"
import script from "./CardDetail.vue?vue&type=script&lang=ts&"
export * from "./CardDetail.vue?vue&type=script&lang=ts&"
import style0 from "./CardDetail.vue?vue&type=style&index=0&id=e5a24b9a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5a24b9a",
  null
  
)

export default component.exports